























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Utils } from '@/services/utils';
import { ElInput } from "element-ui/types/input";
@Component
export default class InputNumber extends Vue {
  @Prop() maxlength!: number;
  @Prop() index!: number;
  @Prop() value!: number;
  @Prop() readonly: any;
  @Prop() disabled: any;
  @Prop() className!: string;
  @Prop() styleInput!: string;
  // @Prop({ default: true }) thousandSeparate: boolean;
  @Prop({ default: "thousand" })
  mode!: string; // mode number output
  @Prop({ default: 1 })
  maxDigi!: number; // mode 'digit' must have maxDigi default 1
  @Prop() padnumber!: number; // mode 'padnumber' zero prefix
  @Prop({ default: -1 })
  maxNumLength!: number;
  @Prop({ default: "medium" })
  size!: string;
  @Prop() placeholder!: string;

  @Prop({ default: false })
  autofocus!: boolean;
  public utils = new Utils();
  public currentValue: any = null;
  public displayValue: any = "";
  timerSelect: any = null;
  isEmit: boolean = false;
  @Prop({ default: false })
  showZero!: boolean;
  @Prop({ default: false })
  dealZero!: boolean; // showZeroに加えて入力も0扱いを優先する
  get getShowZero() {
    return this.showZero || this.dealZero;
  }

  @Prop({ default: false })
  naturalNum: boolean;

  $refs!: {
    input: ElInput;
  };

  @Watch("value")
  onValueChange(value: any, oldVal: any) {
    if (this.isEmit) {
      this.isEmit = false;
    } else {
      this.initValue(value);
    }
  }

  created() {
    this.initValue(this.value);
  }

  mounted() {
    setTimeout(() => {
      if (this.autofocus) {
        this.focus();
      }
    }, 100);
  }

  initValue(value: any) {
    if (value != null) {
      this.value = value;
      this.displayValue = this.value.toString();
      this.textToNumber();
      this.setCurrentValue(false);
      this.numberToText();
      if (this.displayValue == 0 && !this.getShowZero) {
        this.displayValue = "";
      }
    } else {
      this.currentValue = null;
      this.displayValue = null;
      this.$nextTick(() => {
        this.displayValue = "";
      });
    }
    // this.emitValue();
  }

  textToNumber() {
    if (this.displayValue) {
      const num = this.displayValue
        .replace(/[^-.[0-9]/g, "") // allow number - + .
        .replace(/(?!^)-/g, ""); // check negative prefix
      if (this.mode === "digit") {
        this.displayValue = num.replace(/(\..*)\./g, "$1");
      } else if (
        this.mode != "padnumber" &&
        this.mode != "digit" &&
        !this.dealZero &&
        this.currentValue != null
      ) {
        this.$set(this, "displayValue", (+num).toString());
      }
    }
  }

  numberToText() {
    if (isNaN(this.currentValue)) {
      this.currentValue = 0;
    }
    if (
      this.mode === "padnumber" &&
      this.padnumber &&
      this.displayValue != ""
    ) {
      this.$nextTick(() => {
        this.displayValue = this.currentValue.toString().padStart(this.padnumber, "0");
      });
    } else if (this.currentValue == null || this.currentValue == 0) {
      if (!this.getShowZero) {
        this.$nextTick(() => {
          this.displayValue = "";
        });
      } else {
        this.$nextTick(() => {
          this.displayValue = 0;
        });
      }
    } else {
      if (this.mode === "thousand" || this.mode == "number") {
        let txt: string;
        if (this.mode === "thousand") {
          txt = this.currentValue
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        } else {
          txt = this.currentValue.toString();
        }
        this.displayValue = null;
        this.$nextTick(() => {
          this.displayValue = txt;
        });
      } else if (this.mode === "digit") {
        this.$nextTick(() => {
          if (!this.naturalNum) {
            this.displayValue = this.currentValue.toFixed(this.maxDigi);
          } else {
            this.displayValue = this.currentValue.toString();
          }
        });
      }
    }
  }

  onInput(e: any) {
    this.textToNumber();
    this.setCurrentValue();
    this.numberToText();
    this.$emit("onInput");
  }

  onKeypress(e: any) {
    let el = document.activeElement as any;
    if (el.selectionStart != el.selectionEnd) {
      return true;
    } else if (this.maxNumLength > -1) {
      if (this.mode == "digit") {
        const arrNum = e.target.value.split(".");
        if (
          arrNum[0].replace('-', '').length >= this.maxNumLength &&
          e.code.indexOf("Digit") > -1 && 
          e.target.value.indexOf(".") == -1 
        ) {
          if (arrNum.length == 1) {
            e.preventDefault();
          }
        } else if (e.target.value.indexOf(".") > -1) {
          const arr = e.target.value.slice(e.target.value.indexOf(".") + 1);
          if (arr.length >= this.maxDigi - 1 && e.code.indexOf("Digit") > -1) {
            this.goNextInput();
          }
        }
      }
    } else {
      if (e.target.value.length == +this.maxlength - 1) {
        this.goNextInput();
      }
    }
  }

  goNextInput() {
    setTimeout(() => {
      this.blur();
      this.utils.focusNext(this.index);
    }, 0);
  }

  setCurrentValue(doEmit: boolean = true) {
    const str = this.displayValue.replace(/,/g, "");
    this.currentValue = Number(str);
    if (this.dealZero && str == "") {
      this.currentValue = 0;
      this.displayValue = "0";
    } else if (isNaN(Number(str)) || str == "") {
      this.currentValue = null;
    } else {
      this.currentValue = Number(str);
    }
    if (doEmit) {
      this.emitValue();
    }
  }

  clearTimerSelect() {
    if (this.timerSelect) {
      clearTimeout(this.timerSelect);
      this.timerSelect = null;
    }
  }

  onEnter(e: any) {
    this.clearTimerSelect();
    this.utils.focusNext(this.index);
    this.$emit("onEnter", e);
  }

  onFocus() {
    this.clearTimerSelect();
    if (!this.readonly) {
      this.textToNumber();
      this.timerSelect = setTimeout(() => {
        this.$refs.input.select();
      }, 200);
    }
  }

  onBlur(event: any) {
    this.clearTimerSelect();
    this.numberToText();
    // this.emitValue();
    this.$emit("focusout", this.currentValue);
  }

  getValue() {
    return this.currentValue;
  }

  focus() {
    this.$refs.input.focus();
  }

  blur() {
    this.$refs.input.blur();
  }

  onChange(val: any) {
    this.$emit("change", this.currentValue);
  }

  emitValue() {
    if (!this.readonly && !this.disabled) {
      this.isEmit = true;
      this.$emit(
        "input",
        this.mode == "padnumber" ? this.displayValue : this.currentValue
      );
    }
  }
}
